import type { FaireReviewEntity } from "../../entity_types/review";

export const review_r1: FaireReviewEntity = {
  token: "review_r1",
  type: "review",
  brandName: "ROEN",
  reviewerName: "Sarah M.",
  reviewerLocation: "Portland, OR",
  stars: 5,
  reviewText:
    "These candles fly off my shelves! Customers always come back for more. The scent throw is amazing and the packaging is beautiful.",
  reviewDate: "Jan 15, 2026",
  reviewType: "product",
  brandResponse:
    "Hi Sarah! We're so happy to hear La Condesa has been a hit with your customers. The Cedar + Neroli blend was crafted to be exactly that — a crowd-pleaser with serious staying power. Thank you for carrying us!",
  purchasedProductImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/a15d1fc087908754991b018a69774258782ff3fad6f50ef4078fe96c26a1caf6.webp",
  ],
  productImageUrl:
    "https://images.unsplash.com/photo-1602607616777-80c0ddc7a85b?w=80&h=80&fit=crop",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
